"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "enrichINPMeasurement", {
  enumerable: true,
  get: function get() {
    return _inp.enrichINPMeasurement;
  }
});
Object.defineProperty(exports, "enrichLCPMeasurement", {
  enumerable: true,
  get: function get() {
    return _lcp.enrichLCPMeasurement;
  }
});
var _inp = require("./inp");
var _lcp = require("./lcp");